import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';

export const selectProposalCountySchema = createSelectSchema(schema.proposalCounties);

export const insertProposalCountySchema = createInsertSchema(schema.proposalCounties);
